//
// Types
//

export interface Version {
  display: string;
  value: string;
}

export type Chapter = Version[];

//
// Version names and paths
//

const Asmar: Version = {
  display: "Ibn al-Habbariyya (Ar., ed. al-Asmar)",
  value: "IH ed Asmar",
};
const Azzam: Version = {
  display: "Ibn al-Muqaffa‘ (Ar., ed. ‘Azzam)",
  value: "Arabic ed Azzam",
};
const Benfey: Version = {
  display: "Panchatantra (Ger., tr. Benfey)",
  value: "Pan tr Benfey",
};
const Bombay: Version = {
  display: "Ibn al-Habbariyya (Ar., Bombay litho.)",
  value: "IH Bombay 1899",
};
const BrodersenEd: Version = {
  display: "Eugenian Greek (ed. Brodersen)",
  value: "Greek ed Brodersen",
};
const BrodersenTr: Version = {
  display: "Eugenian Greek (Ger., tr. Brodersen)",
  value: "Greek tr Brodersen",
};
const BulaqCelebi: Version = {
  display: "Ali Çelebi (Tur., Bulaq litho.)",
  value: "Celebi Bulaq 1835",
};
const BulaqIM: Version = {
  display: "Ibn al-Muqaffa‘ (Ar., Bulaq ed.)",
  value: "Arabic Bulaq",
};
const Cawnpore: Version = {
  display: "Kashifi (Per., Cawnpore litho.)",
  value: "Kashifi Cawnpore 1880",
};
const Cheikho: Version = {
  display: "Ibn al-Muqaffa‘ (Ar., ed. Cheikho)",
  value: "Arabic ed Cheikho",
};
const DerenbourgCapua: Version = {
  display: "De Capua (Lat., ed. Derenbourg)",
  value: "Capua ed Derenbourg",
};
const DerenbourgJoel: Version = {
  display: "R. Joel (Heb./Fr., ed./tr. Derenbourg)",
  value: "Joel ed tr Derenbourg",
};
const Dohla: Version = {
  display: "Old Castilian (ed. Döhla)",
  value: "Castilian ed Dohla",
};
const Donas: Version = {
  display: "Exemplario (Sp., ed. Doñas et al.)",
  value: "Exemplario ed Donas et al",
};
const Falconer: Version = {
  display: "New Syriac (Eng., tr. Keith-Falconer)",
  value: "New Syriac tr KF",
};
const Fishbein: Version = {
  display: "Ibn al-Muqaffa‘ (Ar., ed. Fishbein)",
  value: "Arabic ed Fishbein",
};
const FishMont: Version = {
  display: "Ibn al-Muqaffa‘ (Eng., tr. F. & M.)",
  value: "IM tr FishMont",
};
const Gehlhar: Version = {
  display: "Bukhari (Per., ed. Gehlhar)",
  value: "Bukhari ed Gehlhar",
};
const GeisslerEd: Version = {
  display: "De Capua (Lat., ed. Geissler)",
  value: "Capua ed Geissler",
};
const GeisslerPforr: Version = {
  display: "A. v. Pforr (Ger., ed. Geissler)",
  value: "Pforr ed Geissler",
};
const GeisslerTr: Version = {
  display: "De Capua (Ger., tr. Geissler)",
  value: "Capua tr Geissler",
};
const Hilka: Version = {
  display: "Latin via Greek (ed. Hilka)",
  value: "Latin ed Hilka",
};
const Holland: Version = {
  display: "A. v. Pforr (Ger., ed. Holland)",
  value: "Pforr ed Holland",
};
const Khanlari: Version = {
  display: "Bukhari (Per., ed. Kh. & R.)",
  value: "Bukhari ed Khanlari and Rawshan",
};
const Knatchbull: Version = {
  display: "Ibn al-Muqaffa‘ (Eng., tr. Knatchbull)",
  value: "IM tr Knatchbull",
};
const Minuvi: Version = {
  display: "Munshi (Per., ed. Minuvi)",
  value: "Munshi ed Minuvi",
};
const Miquel: Version = {
  display: "Ibn al-Muqaffa‘ (Fr., tr. Miquel)",
  value: "IM tr Miquel",
};
const NajmWeb: Version = {
  display: "Munshi (Ger., tr. N. & W.)",
  value: "Munshi tr NajmWeb",
};
const NobleEd: Version = {
  display: "Eugenian Greek (ed. Noble)",
  value: "Eugenian ed Noble",
};
const NobleTr: Version = {
  display: "Eugenian Greek (Eng., tr. Noble)",
  value: "Eugenian tr Noble",
};
const NoldekeBurzoe: Version = {
  display: "Ibn al-Muqaffa‘ (Ger., tr. Nöldeke)",
  value: "IM tr Noldeke",
};
const Olivelle: Version = {
  display: "Panchatantra (Eng., tr. Olivelle)",
  value: "Pan tr Olivelle",
};
const Puntoni: Version = {
  display: "Eugenian Greek (ed. Puntoni)",
  value: "Greek ed Puntoni",
};
const RabiiEd: Version = {
  display: "al-Saghani (Ar., ed. El-Rabi‘i)",
  value: "Saghani ed Rabii",
};
const RabiiTr: Version = {
  display: "al-Saghani (Fr., tr. El-Rabi‘i)",
  value: "Saghani tr Rabii",
};
const Rawshan: Version = {
  display: "Kashifi (Per., ed. Rawshan)",
  value: "Kashifi ed Rawshan",
};
const Sacy: Version = {
  display: "Ibn al-Muqaffa‘ (Ar., ed. Sacy)",
  value: "Arabic ed Sacy",
};
const SchultEd: Version = {
  display: "Old Syriac (ed. Schulthess)",
  value: "Old Syriac ed Schulthess",
};
const Schulthess: Version = {
  display: "Old Syriac (Ger., tr. Schulthess)",
  value: "Old Syriac tr Schulthess",
};
const Shidfar: Version = {
  display: "Ibn al-Muqaffa‘ (Rus., tr. Shidfar)",
  value: "IM tr Shidfar",
};
const Sjoeberg: Version = {
  display: "Simeon Seth (Gr., ed. Sjöberg)",
  value: "Greek ed Sjoeberg",
};
const StarckEd: Version = {
  display: "Eugenian Greek (ed. Starck)",
  value: "Greek ed Starck",
};
const StarckTr: Version = {
  display: "Eugenian Greek (Lat., tr. Starck)",
  value: "Greek tr Starck",
};
const Thackston: Version = {
  display: "Munshi (Eng., tr. Thackston)",
  value: "Munshi tr Thackston",
};
const Tudiva: Version = {
  display: "Tusi (Per., ed. Todua)",
  value: "Tusi ed Tudiva",
};
const Wolff: Version = {
  display: "Ibn al-Muqaffa‘ (Ger., tr. Wolff)",
  value: "IM tr Wolff",
};
const Wollaston: Version = {
  display: "Kashifi (Eng., tr. Wollaston)",
  value: "Kashifi tr Wollaston",
};
const Wright: Version = {
  display: "New Syriac (ed. Wright)",
  value: "New Syriac ed Wright",
};

//
// Versions available for each chapter
//

export const As: Chapter = [
  Cheikho,
  Sacy,
  BulaqIM,
  Knatchbull,
  Miquel,
  Shidfar,
];
export const IHP: Chapter = [Bombay, Asmar];
export const IHI: Chapter = [Bombay];
export const SagP: Chapter = [RabiiEd, RabiiTr];
export const PanP: Chapter = [Benfey, Olivelle];
export const EugP: Chapter = [NobleEd, NobleTr];
export const CapP: Chapter = [DerenbourgCapua, GeisslerEd, GeisslerTr, Donas];
export const MunP: Chapter = [Minuvi, Thackston, NajmWeb];
export const BukP: Chapter = [Gehlhar, Khanlari];
export const TusP: Chapter = [Tudiva];
export const KasP: Chapter = [Rawshan, Cawnpore, Wollaston, BulaqCelebi];
export const KasI: Chapter = [Rawshan, Cawnpore, Wollaston, BulaqCelebi];

export const Im: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Shidfar,
  RabiiEd,
  RabiiTr,
  Gehlhar,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  NobleEd,
  Puntoni,
  NobleTr,
  Hilka,
  Dohla,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Lv: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Shidfar,
  RabiiEd,
  RabiiTr,
  Gehlhar,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  NobleEd,
  Puntoni,
  NobleTr,
  Hilka,
];

export const Sv: Chapter = [
  Dohla,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Bu: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Shidfar,
  NoldekeBurzoe,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Gehlhar,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Wright,
  Falconer,
  NobleEd,
  Puntoni,
  NobleTr,
  Hilka,
  Dohla,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Lo: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Gehlhar,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Benfey,
  Olivelle,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  Sjoeberg,
  NobleEd,
  Puntoni,
  BrodersenEd,
  StarckEd,
  NobleTr,
  BrodersenTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Di: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Wright,
  Falconer,
  Sjoeberg,
  NobleEd,
  Puntoni,
  BrodersenEd,
  StarckEd,
  NobleTr,
  BrodersenTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Rd: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Benfey,
  Olivelle,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  Sjoeberg,
  NobleEd,
  Puntoni,
  BrodersenEd,
  StarckEd,
  NobleTr,
  BrodersenTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Oc: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Benfey,
  Olivelle,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  Sjoeberg,
  NobleEd,
  Puntoni,
  BrodersenEd,
  StarckEd,
  NobleTr,
  BrodersenTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const At: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Benfey,
  Olivelle,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  Sjoeberg,
  NobleEd,
  Puntoni,
  BrodersenEd,
  StarckEd,
  NobleTr,
  BrodersenTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Aw: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Benfey,
  Olivelle,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  Sjoeberg,
  NobleEd,
  Puntoni,
  BrodersenEd,
  StarckEd,
  NobleTr,
  BrodersenTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Kd: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  Sjoeberg,
  NobleEd,
  Puntoni,
  BrodersenEd,
  StarckEd,
  NobleTr,
  BrodersenTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Km: Chapter = [
  Azzam,
  Cheikho,
  Miquel,
  Shidfar,
  SchultEd,
  Schulthess,
  NobleEd,
  Puntoni,
  StarckEd,
  NobleTr,
  StarckTr,
];

export const Mc: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  NobleEd,
  Puntoni,
  StarckEd,
  NobleTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Kb: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  Sjoeberg,
  NobleEd,
  Puntoni,
  BrodersenEd,
  StarckEd,
  NobleTr,
  BrodersenTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Lj: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  SchultEd,
  Schulthess,
  Wright,
  Falconer,
  NobleEd,
  Puntoni,
  StarckEd,
  NobleTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Tg: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  Minuvi,
  Thackston,
  NajmWeb,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Wright,
  Falconer,
  NobleEd,
  Puntoni,
  StarckEd,
  NobleTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Ks: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  Khanlari,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Wright,
  Falconer,
  NobleEd,
  Puntoni,
  StarckEd,
  NobleTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Lh: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Wright,
  Falconer,
  NobleEd,
  Puntoni,
  StarckEd,
  NobleTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Ag: Chapter = [
  Fishbein,
  Azzam,
  Cheikho,
  Sacy,
  BulaqIM,
  FishMont,
  Knatchbull,
  Miquel,
  Wolff,
  Shidfar,
  Bombay,
  Asmar,
  RabiiEd,
  RabiiTr,
  Minuvi,
  Thackston,
  NajmWeb,
  Tudiva,
  Rawshan,
  Cawnpore,
  Wollaston,
  BulaqCelebi,
  Wright,
  Falconer,
  NobleEd,
  Puntoni,
  StarckEd,
  NobleTr,
  StarckTr,
  Hilka,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Kw: Chapter = [
  Miquel,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const Df: Chapter = [
  Azzam,
  Cheikho,
  Miquel,
  Shidfar,
  BulaqIM,
  Asmar,
  Dohla,
  DerenbourgJoel,
  DerenbourgCapua,
  GeisslerEd,
  GeisslerTr,
  GeisslerPforr,
  Holland,
  Donas,
];

export const IHC: Chapter = [Bombay, Asmar];
export const MunC: Chapter = [Minuvi, NajmWeb];
export const TusC: Chapter = [Tudiva];
